import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState, useEffect } from 'react';
import clsx from 'clsx';
import { FormikContext } from 'formik';
import { default as _get } from 'lodash/get';
import Select from '../Select/Select';
import Button from '../Button/Button';
import TextField from '../TextField/TextField';
import useStyles from './AddEditRemindersForm.styles';
import { SiteContext, prepareNDigitArray, isMobileDevice } from '../../utils/common';
import { monthsList } from './utils';
let daysInMonth = prepareNDigitArray(31);
const AddEditRemindersForm = (props) => {
    const { classes } = useStyles();
    const formikContext = useContext(FormikContext);
    const { isEdit, occasion, isSubmitting } = props;
    const isMobile = isMobileDevice();
    const isMobilePortrait = isMobile && window.matchMedia('(orientation: portrait)').matches;
    const { occasions = [], isFlyingFlowers } = useContext(SiteContext);
    const [isPredeterminedDate, setDisableDateFields] = useState(false);
    const [showRequiredText, setShowRequiredText] = useState(!isMobilePortrait);
    const occasionsList = occasions === null || occasions === void 0 ? void 0 : occasions.filter((occasion) => {
        var _a;
        return (_a = occasion === null || occasion === void 0 ? void 0 : occasion.occasionReminders) === null || _a === void 0 ? void 0 : _a.isActive;
    }).map((occ) => {
        return {
            label: occ.label,
            value: occ.label,
        };
    });
    useEffect(() => {
        occasion && checkIfPredeterminedOccasion(occasion);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const handleOrientationChange = () => {
            const toBePortrait = window.matchMedia('(orientation: landscape)').matches; // gives the current orientation
            setShowRequiredText(!(isMobile && toBePortrait));
        };
        window === null || window === void 0 ? void 0 : window.addEventListener('orientationchange', handleOrientationChange);
        return () => {
            window === null || window === void 0 ? void 0 : window.removeEventListener('orientationchange', handleOrientationChange);
        };
    }, [isMobile]);
    const handleMonthChange = (e) => {
        const month = e.target.value;
        const day = _get(formikContext === null || formikContext === void 0 ? void 0 : formikContext.values, 'day');
        const monthIndex = monthsList.findIndex((val) => val.value === month);
        formikContext.setFieldValue('month', month);
        if (day > monthsList[monthIndex].length)
            formikContext.setFieldValue('day', '');
        daysInMonth = prepareNDigitArray(monthsList[monthIndex].length);
    };
    const handleOccasionChange = (e) => {
        const selectedOccasion = e.target.value;
        formikContext.setFieldValue('occasion', selectedOccasion);
        checkIfPredeterminedOccasion(selectedOccasion);
    };
    const checkIfPredeterminedOccasion = (occasion) => {
        var _a, _b;
        const selectedOccasionInfo = occasions.find((occ) => {
            if (occ.label === occasion) {
                return occ.occasionReminders;
            }
        });
        const preDeterminedOccasionDate = ((_a = selectedOccasionInfo === null || selectedOccasionInfo === void 0 ? void 0 : selectedOccasionInfo.occasionReminders) === null || _a === void 0 ? void 0 : _a.preDeterminedOccasionDate) || '';
        const isPredeterminedDate = (_b = selectedOccasionInfo === null || selectedOccasionInfo === void 0 ? void 0 : selectedOccasionInfo.occasionReminders) === null || _b === void 0 ? void 0 : _b.isPredeterminedDate;
        if (isPredeterminedDate) {
            setDisableDateFields(true);
            const [, month, day] = preDeterminedOccasionDate.split('-');
            formikContext.setFieldValue('day', day);
            formikContext.setFieldValue('month', month);
        }
        else {
            setDisableDateFields(false);
        }
    };
    return (_jsxs("div", { children: [_jsx("div", { className: classes.headings, children: "Name" }), _jsx("div", { className: classes.input, children: _jsx(TextField, { name: 'firstName', label: "First name (Required)", placeholder: isFlyingFlowers ? 'e.g. John' : 'e.g. Rose', fullWidth: true, hideRequiredOptional: true, required: true, inputProps: { maxLength: 50 } }) }), _jsx("div", { className: clsx(classes.input, classes.inputMedium), children: _jsx(TextField, { name: 'lastName', label: "Last name (Required)", placeholder: isFlyingFlowers ? 'e.g. Smith' : 'e.g. Thorne', fullWidth: true, hideRequiredOptional: true, inputProps: { maxLength: 40 } }) }), _jsx("div", { className: classes.headings, children: "Occasion" }), _jsx("div", { className: clsx(classes.input, classes.inputMedium), children: _jsx(Select, { name: "occasion", label: "Occasion (Required)", placeholder: "Choose an occasion", items: occasionsList, fullWidth: true, required: true, hideRequiredOptional: true, onChange: handleOccasionChange }) }), _jsx("div", { className: classes.headings, children: "Date" }), _jsxs("div", { className: classes.dateFields, children: [_jsx("div", { className: classes.dateField, children: _jsx(Select, { name: "day", label: `Day${showRequiredText ? ' (Required)' : ''}`, items: daysInMonth, hideRequiredOptional: true, required: true, disabled: isPredeterminedDate, fullWidth: true }) }), _jsx("div", { className: classes.dateField, children: _jsx(Select, { name: "month", label: `Month${showRequiredText ? ' (Required)' : ''}`, items: monthsList, hideRequiredOptional: true, required: true, onChange: handleMonthChange, fullWidth: true, disabled: isPredeterminedDate }) })] }), _jsx("div", { className: classes.buttons, children: _jsx(Button, { fullWidth: true, title: isEdit ? 'Save reminder' : 'Set reminder', className: classes.saveButton, isSubmit: true, variant: isFlyingFlowers ? 'secondaryDark' : 'primary', icon: isFlyingFlowers ? 'sentiment_very_satisfied' : undefined, disabled: isSubmitting }) }), _jsx("div", { children: !isEdit ? (_jsx("div", { className: classes.reminderMessage, children: "When you set up a reminder, we will send you a reminder email 10 and 5 days before the occasion date and on the day too (we don\u2019t want you to forget). If at a later date you decide you don\u2019t want to receive reminder emails, please log into your account and delete your reminders." })) : ('') })] }));
};
export default AddEditRemindersForm;
